module.exports = __webpack_public_path__ + "img/charette_cover.2d6fd747.jpg";